import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as reservationActions from '../../actions/reservations';
import ReservationPage from './ReservationPage';

const onTrigger = (event, data) => {
  console.log('window.xprops.onTrigger not found', event, data);
};

const mapStateToProps = ({ settings }) => ({
  ...settings,
  isDemo: window.bta.isDemo,
  timeZone: window.bta.timeZone,
  onTrigger: window.xprops ? window.xprops.onTrigger : onTrigger,
});

const mapDispatchToProps = (dispatch) => ({
  reservationActions: bindActionCreators({ ...reservationActions }, dispatch),
});

const ReservationPageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReservationPage);

export default ReservationPageConnected;
